module.exports = __webpack_public_path__ + "static/img/8.4da27660.jpg";